// src/helpers/rutaEmpresas.js
import axios from "axios";

// Base sin slash final
const RAW_BASE_URL =
  import.meta.env?.VITE_API_URL || "https://backsanpancracio.us-3.evennode.com";
const BASE_URL = RAW_BASE_URL.replace(/\/+$/, "");

// Instancia axios unificada para este helper
const API = axios.create({ baseURL: BASE_URL });

// Path helper: sin doble slash y sin slash inicial
const p = (s) => String(s || "").replace(/^\/+/, "");

// Header con token (si existe)
const auth = () => {
  const token = localStorage.getItem("token") || "";
  return token ? { headers: { token } } : {};
};

// Limpieza de payloads (evita mandar "", null, undefined)
const clean = (obj = {}) =>
  Object.fromEntries(
    Object.entries(obj).filter(
      ([, v]) => v !== "" && v !== null && v !== undefined
    )
  );

// DEBUG: imprime la URL final de la request
const debugUrl = (url, params) => {
  console.log("👉 URL:", API.getUri({ url, params }));
};

// ---- EMPRESAS ----

// GET lista (acepta filtros en params, ej: { q, activo, tipo })
export const getEmpresas = async (params = {}) => {
  const url = p("empresas");
  debugUrl(url, params);
  const { data } = await API.get(url, { ...auth(), params });
  // Devuelve array robusto (data.empresas || data || [])
  return Array.isArray(data?.empresas) ? data.empresas : (Array.isArray(data) ? data : []);
};

export const getEmpresaById = async (id) => {
  const url = p(`empresas/${id}`);
  debugUrl(url);
  const { data } = await API.get(url, auth());
  return data; // { ok, empresa } o el doc directo según tu back
};

export const postEmpresa = async (payload) => {
  const url = p("empresas");
  debugUrl(url);
  const { data } = await API.post(url, clean(payload), auth());
  return data; // { ok, empresa }
};

export const putEmpresa = async (id, payload) => {
  const url = p(`empresas/${id}`);
  debugUrl(url);
  const { data } = await API.put(url, clean(payload), auth());
  return data; // { ok, empresa }
};

export const deleteEmpresa = async (id) => {
  const url = p(`empresas/${id}`);
  debugUrl(url);
  const { data } = await API.delete(url, auth());
  return data; // { ok, empresa }
};
